import request from "./http";

export const region = (params) =>
  request({
    url: "/ym/region",
    method: "post",
    data: params,
  });

export const getRegionCode = (params) =>
  request({
    url: "/common/getRegionCode",
    method: "get",
    params,
  });
export const getResetPwdCode = (params) =>
  request({
    url: "/common/getResetPwdCode",
    method: "get",
    params,
  });

export const Login = (params) =>
  request({
    url: "/ym/login",
    method: "post",
    data: params,
  });
export const wxKbList = (params) =>
  request({
    url: "/system/wxKb/list",
    method: "post",
    data: params,
  });

export const changeMusicType = (params) =>
  request({
    url: "/ym/changeMusicType",
    method: "post",
    data: params,
  });

export const resetPwd = (params) =>
  request({
    url: "/ym/resetPwd",
    method: "post",
    data: params,
  });
export const batchSave = (params) =>
  request({
    url: "/system/wxKbUser/batchSave",
    method: "post",
    data: params,
  });

export const getMusicByAlbumId = (params) =>
  request({
    url: "/ym/getMusicByAlbumId",
    method: "get",
    params,
  });
export const getUserCount = (params) =>
  request({
    url: "/ym/getUserCount",
    method: "get",
    params,
  });

export const todayList = (params) =>
  request({
    url: "/ym/todayList",
    method: "get",
    params,
  });
export const getCurTime = (params) =>
  request({
    url: "/ym/getCurTime",
    method: "get",
    params,
  });
export const getNextPlayInfo = (params) =>
  request({
    url: "/system/wxKbUser/getNextPlayInfo",
    method: "get",
    params,
  });
